const ENTERED_NAME_KEY = "qrs.enteredName";
const ENTERED_NAME_COOKIE = "qrs_entered_name";
const ADMIN_TOKEN_KEY = "qrs.adminToken";
const STOCK_EDIT_TOKEN_KEY = "qrs.stockEditToken";

function getCookieValue(key: string): string {
  if (typeof document === "undefined") return "";
  const cookie = document.cookie
    .split(";")
    .map((entry) => entry.trim())
    .find((entry) => entry.startsWith(`${key}=`));
  if (!cookie) return "";
  const value = cookie.slice(key.length + 1);
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

function setCookieValue(key: string, value: string): void {
  if (typeof document === "undefined") return;
  const encoded = encodeURIComponent(value);
  document.cookie = `${key}=${encoded}; Path=/; Max-Age=31536000; SameSite=Lax`;
}

export function getStoredEnteredName(): string {
  const fromCookie = getCookieValue(ENTERED_NAME_COOKIE);
  if (fromCookie) return fromCookie;

  if (typeof window === "undefined") return "";

  const fromStorage = sessionStorage.getItem(ENTERED_NAME_KEY) ?? localStorage.getItem(ENTERED_NAME_KEY) ?? "";
  if (fromStorage) {
    setCookieValue(ENTERED_NAME_COOKIE, fromStorage);
    return fromStorage;
  }

  return "";
}

export function setStoredEnteredName(value: string): void {
  const normalized = value.trim();
  setCookieValue(ENTERED_NAME_COOKIE, normalized);

  if (typeof window === "undefined") return;
  sessionStorage.setItem(ENTERED_NAME_KEY, normalized);
  localStorage.setItem(ENTERED_NAME_KEY, normalized);
}

export function getAdminToken(): string {
  return sessionStorage.getItem(ADMIN_TOKEN_KEY) ?? "";
}

export function setAdminToken(token: string): void {
  sessionStorage.setItem(ADMIN_TOKEN_KEY, token);
}

export function clearAdminToken(): void {
  sessionStorage.removeItem(ADMIN_TOKEN_KEY);
}

export function getStockEditToken(): string {
  return sessionStorage.getItem(STOCK_EDIT_TOKEN_KEY) ?? "";
}

export function setStockEditToken(token: string): void {
  sessionStorage.setItem(STOCK_EDIT_TOKEN_KEY, token);
}

export function clearStockEditToken(): void {
  sessionStorage.removeItem(STOCK_EDIT_TOKEN_KEY);
}
